import React from 'react';
import Tooltip from './Tooltip';
import Assets from '../../Assets';

export default class Information extends React.Component {

    render() {
        if (!this.props.information) {
            return <React.Fragment/>
        }

        const icon = Assets.info;
        return <Tooltip icon={icon} style={'green'} text={this.props.information.text}/>
    }
}